module.exports = __webpack_public_path__ + "static/media/twinshadow-caer.2a38ba41.jpg";